var map = {
	"./apple-touch-icon-114x114": 497,
	"./apple-touch-icon-114x114.png": 497,
	"./apple-touch-icon-120x120": 498,
	"./apple-touch-icon-120x120.png": 498,
	"./apple-touch-icon-144x144": 499,
	"./apple-touch-icon-144x144.png": 499,
	"./apple-touch-icon-152x152": 500,
	"./apple-touch-icon-152x152.png": 500,
	"./apple-touch-icon-167x167": 501,
	"./apple-touch-icon-167x167.png": 501,
	"./apple-touch-icon-180x180": 502,
	"./apple-touch-icon-180x180.png": 502,
	"./apple-touch-icon-57x57": 503,
	"./apple-touch-icon-57x57.png": 503,
	"./apple-touch-icon-60x60": 504,
	"./apple-touch-icon-60x60.png": 504,
	"./apple-touch-icon-72x72": 505,
	"./apple-touch-icon-72x72.png": 505,
	"./apple-touch-icon-76x76": 506,
	"./apple-touch-icon-76x76.png": 506,
	"./favicon-128": 507,
	"./favicon-128.png": 507,
	"./favicon-16x16": 508,
	"./favicon-16x16.png": 508,
	"./favicon-196x196": 509,
	"./favicon-196x196.png": 509,
	"./favicon-32x32": 510,
	"./favicon-32x32.png": 510,
	"./favicon-96x96": 511,
	"./favicon-96x96.png": 511,
	"./favicon.ico": 1022,
	"./mstile-144x144": 512,
	"./mstile-144x144.png": 512,
	"./mstile-150x150": 513,
	"./mstile-150x150.png": 513,
	"./mstile-310x150": 514,
	"./mstile-310x150.png": 514,
	"./mstile-310x310": 515,
	"./mstile-310x310.png": 515,
	"./mstile-70x70": 516,
	"./mstile-70x70.png": 516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1021;